import React from "react";
import { CTAButton } from "./CTAButton";
export function OfferTeaser() {
  return <section className="bg-gold-400 px-5 py-12 text-navy-950" data-id="element-248" data-mp="31p1wozkw47sv">
      <div className="mx-auto max-w-2xl text-center" data-id="element-249" data-mp="31qwish7we5yj">
        <h2 className="font-display text-3xl font-black leading-tight sm:text-4xl" data-id="element-250" data-mp="3gmcf6svyady3">
          Your complete denture assessment toolkit is waiting for you.
        </h2>
        <p className="mt-3 text-base font-medium text-navy-800" data-id="element-251" data-mp="3pmr3m147o95t">
          Explore the six volumes and five exclusive bonuses included in Denture Blueprint™.
        </p>
        <div className="mt-7 [&_a]:bg-navy-950 [&_a]:text-gold-300 [&_a]:ring-navy-800 [&_a:hover]:bg-navy-800" data-id="element-252" data-mp="3kne86rz9xtrm">
          <CTAButton label="Get My Denture Blueprint — $27" sub="Instant Download · No Monthly Fees · Lifetime Access" data-id="element-253" data-mp="390pcmjowl8i" />
        </div>
        <p className="mt-2 text-xs text-navy-800" data-id="element-254" data-mp="c7cojcymgrck">The checkout will display the applicable currency and taxes, if any.</p>
      </div>
    </section>;
}